export const ADMIN_ADDRESSES = [
  "0x9bb58298f032ce3bf60b2bc5f23a9908362af0e1",
  "0:a4a78a55b6d457a9e12f26748f2418d795fbdddb48ff7d239a53dc196e0cac3d",
  "0:bfe3489d2327dd38638dafdfb0789e92dd8884859d21bef6522615fcf86cefd1",
];
